<template>
  <div>
    <common-table v-if="pageData.viewMode==='list'" />
    <edit-form v-else-if="pageData.viewMode==='info'" ref="form" />
  </div>
</template>
<script>
import CommonTable from "@/components/commonPage/components/CommonTable.vue"
import EditForm from "@/components/commonPage/components/EditForm.vue"

export default {
  name: "EditPage",
  components: { CommonTable, EditForm },
  inject: ["pageData"]
}
</script>

<style scoped lang="scss">

</style>
